import React, {Component} from 'react';
import PropTypes from 'prop-types';

export default class Header extends Component {
  static propTypes = {
    arrCourses: PropTypes.array,
    eventsLength: PropTypes.number,
    resortAbbr: PropTypes.string
  }

  static defaultProps = {
    arrCourses: [],
    eventsLength: 0,
    resortAbbr: 'BTC'
  }

  state = {
    selectResort: {},
    resort: '',
    abbr: ''
  }

  componentDidMount = () => {
    this.setResortData(this.props.resortAbbr);
  }

  componentWillReceiveProps = (nextProps) => {
    this.setResortData(nextProps.resortAbbr);
  }

  setResortData = (resortAbbr) => {
    for(const resort of beaches_app.page.resortList) {
      if(resort.code === resortAbbr) {
        this.setState({selectResort: resort}, () => {
          this.setState({resort: this.state.selectResort.shortName.replace('Beaches ', '')});
        });
      }
    }
  }

  render() {
    const {eventsLength} = this.props;
    const {
      selectResort,
      resort
    } = this.state;

    return(
      <div className="courses-sort__header">
        <i className="icon-beaches" />

        <h2 className="courses-sort__title">
          {resort}
        </h2>

        <div className="courses-sort__sub-title">
          {selectResort.city}, {selectResort.countryName}
        </div>

        <div className="courses-sort__count">
          <span>{eventsLength} Dive courses found</span> at {selectResort.shortName}
        </div>
      </div>
    );
  }
}
